import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, errorText } from "../../lib/api";
import { humanDate } from "../forms/SlotPicker";

const allSlots = (iso) => {
  if (!iso) return [];
  const [y, m, d] = iso.split("-").map(Number);
  const wd = new Date(y, m - 1, d).getDay();
  if (wd === 0) return [];
  const end = wd === 6 ? 11 * 60 + 45 : 17 * 60;
  const out = [];
  for (let t = 8 * 60 + 30; t <= end; t += 15) out.push(`${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`);
  return out;
};

export function AvailabilityTab() {
  const [blocks, setBlocks] = useState([]);
  const [f, setF] = useState({ date: "", time: "", reason: "" });
  const load = () => api.get("/admin/blocks").then((r) => setBlocks(Array.isArray(r.data) ? r.data : [])).catch((e) => toast.error(errorText(e)));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/blocks", { date: f.date, time: f.time || null, reason: f.reason });
      toast.success("Indisponibilité ajoutée");
      setF({ ...f, time: "", reason: "" });
      load();
    } catch (err) {
      toast.error(errorText(err));
    }
  };
  const del = async (id) => { await api.delete(`/admin/blocks/${id}`); load(); };
  const slots = allSlots(f.date);
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <form onSubmit={add} className="space-y-3 rounded-2xl bg-white p-6 ring-1 ring-slate-200" data-testid="block-form">
        <p className="font-display text-lg font-bold text-ag-ink">Bloquer une journée ou un créneau</p>
        <p className="text-sm text-slate-600">Les créneaux bloqués ne sont plus proposés aux clients. Les rendez-vous déjà enregistrés ne sont pas modifiés.</p>
        <input type="date" required className="field" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value, time: "" })} data-testid="block-date" />
        <select className="field" value={f.time} onChange={(e) => setF({ ...f, time: e.target.value })} disabled={!slots.length} data-testid="block-time">
          <option value="">Toute la journée</option>
          {slots.map((t) => <option key={t} value={t}>{t.replace(":", "h")}</option>)}
        </select>
        {f.date && !slots.length && <p className="text-sm text-slate-500">Le centre est déjà fermé ce jour-là.</p>}
        <input className="field" placeholder="Motif (optionnel, interne)" value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} data-testid="block-reason" />
        <button disabled={!slots.length} className="btn btn-blue" data-testid="block-submit">Bloquer</button>
      </form>
      <div className="rounded-2xl bg-white ring-1 ring-slate-200" data-testid="blocks-list">
        <p className="border-b border-slate-100 p-4 font-display text-lg font-bold text-ag-ink">Indisponibilités à venir</p>
        {blocks.length === 0 && <p className="p-4 text-sm text-slate-500">Aucune indisponibilité.</p>}
        {blocks.map((b) => (
          <div key={b.id} className="flex items-center justify-between gap-3 border-b border-slate-100 p-4 text-sm last:border-0">
            <span><span className="font-semibold first-letter:uppercase">{humanDate(b.date)}</span> · {b.time ? b.time.replace(":", "h") : "Toute la journée"}{b.reason ? ` · ${b.reason}` : ""}</span>
            <button onClick={() => del(b.id)} aria-label="Supprimer" data-testid={`block-delete-${b.id}`}><Trash2 className="h-4 w-4 text-slate-500 hover:text-red-600" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
